const STORAGE_KEY = "steam-recent-orders";
const MAX_ORDERS = 5;

function readAll() {
  try {
    const list = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || "[]");
    return Array.isArray(list) ? list.filter((item) => item && item.orderId) : [];
  } catch {
    return [];
  }
}

function writeAll(list) {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(list));
  } catch {
    /* ignore quota errors */
  }
}

/** Заказ пополнения Steam в памяти вкладки; тот же orderId перезаписывается. */
export function saveSteamOrder(order) {
  if (!order?.orderId) {
    return;
  }
  const rest = readAll().filter((item) => item.orderId !== order.orderId);
  writeAll([{ ...order, savedAt: order.savedAt || Date.now() }, ...rest].slice(0, MAX_ORDERS));
}

/** Новая ссылка или QR после смены способа оплаты; savedAt не меняется. */
export function updateSteamOrderPayment(orderId, { paymentUrl = null, qrCode = null } = {}) {
  const list = readAll();
  const item = list.find((entry) => entry.orderId === orderId);
  if (!item) {
    return;
  }
  item.paymentUrl = paymentUrl;
  item.qrCode = qrCode;
  writeAll(list);
}

export function getSteamOrders() {
  return readAll();
}

export function getLatestSteamOrder() {
  return readAll()[0] || null;
}

export function forgetSteamOrder(orderId) {
  writeAll(readAll().filter((item) => item.orderId !== orderId));
}
